import {inject, Injectable} from "@angular/core";
import {LightboxComponent} from "./lightbox.component";
import {DialogService} from "../dialog/dialog.service";

@Injectable({providedIn: "root"})
export class LightboxService {
    private dialogService = inject(DialogService);

    open(photos: string[], initialIndex = 0) {
        return this.dialogService.open(LightboxComponent, {
            data: {photos, initialIndex},
            panelClass: "lightbox-dialog-panel",
            width: "100vw",
            height: "100vh",
            maxWidth: "100vw",
            maxHeight: "100vh",
            hasBackdrop: false,
        });
    }
}